export const REQUIRED_INVOICE = "REQUIRED_INVOICE" as const;
export const REQUIRED_INVOICE_LINE_ITEM = "REQUIRED_INVOICE_LINE_ITEM" as const;
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE" as const;
export const UPDATE_COMPANY_LOGO = "UPDATE_COMPANY_LOGO" as const;
export const ADD_USER_PROFILE = "ADD_USER_PROFILE" as const;
export const UPDATE_FORMDATA = "UPDATE_FORMDATA" as const;
export const TURN_FLAG = "TURN_FLAG" as const;
export const NOTIFY_COUNT = "NOTIFY_COUNT" as const;
export const ISUPDATED = "ISUPDATED" as const;

export interface UserDetails {
  profilePic: string | null;
  userName: string | null;
}

export interface TeamDetails {
  companyLogo: string | null;
}

export type AppAction =
  | { type: typeof REQUIRED_INVOICE; payload: unknown[] }
  | { type: typeof REQUIRED_INVOICE_LINE_ITEM; payload: unknown[] }
  | { type: typeof ADD_USER_PROFILE; payload: UserDetails }
  | { type: typeof UPDATE_USER_PROFILE; payload: string | null; userName: string | null }
  | { type: typeof UPDATE_COMPANY_LOGO; payload: string | null }
  | { type: typeof UPDATE_FORMDATA; payload: Record<string, unknown> }
  | { type: typeof TURN_FLAG; payload: boolean }
  | { type: typeof NOTIFY_COUNT; payload: number }
  | { type: typeof ISUPDATED; payload: boolean };
